// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--z4h0w","scroller":"_0bc5e8de02--scroller--qm89c"};